import { IApplicationState } from '../../types/redux';

export function selectDealProcessVideoIframeUrl(state: IApplicationState) {
  return state.links.dealProcessVideoIframeUrl;
}
